import { render, staticRenderFns } from "./TenantDisableConfirmationModal.vue?vue&type=template&id=77c27034&"
import script from "./TenantDisableConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./TenantDisableConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports